import { render, staticRenderFns } from "./BuckUBack.vue?vue&type=template&id=05ff1b76&"
import script from "./BuckUBack.vue?vue&type=script&lang=ts&"
export * from "./BuckUBack.vue?vue&type=script&lang=ts&"
import style0 from "./BuckUBack.vue?vue&type=style&index=0&id=05ff1b76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports